import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useCustomer from 'src/hooks/useCustomer';

const DashboardRedirect: FC<React.PropsWithChildren<unknown>> = () => {
  const navigate = useNavigate();
  const { customer } = useCustomer();

  useEffect(() => {
    navigate(`/${customer.number || 0}`, { replace: true });
  }, [customer.number]);

  return <div></div>;
};

export default DashboardRedirect;
